import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../config";

import Observer from "../utils/observer";
import TicketLogic from "../utils/ticket-logic";
import { EmptyRecordsMessage, Pagination, Row } from "../utils/table-utils";
import { OUTCOMES_STATUS } from "../utils/ticket-statuses";

import CashoutService from "../../../services/cashout";
import LFeed from "../../../services/live-feed";

import * as C from "../desktop-templates/cashout-enhanced";
import User from "../../../services/user";

export default function CashoutEnhanced() {
    return <div class="rounded-lg">{/*overflow-hidden*/}
        <div class="p-3 bg-kobaaccent-400 text-slate-950 h-10 uppercase text-base"><Trans>Cashout</Trans>
            <div class="hidden rounded-lg bg-slate-50 text-slate-950 text-xl py-2 px-3"></div>
        </div>
        <CashoutPage />
    </div>;
}


export class CashoutPage extends Component {
    state = {
        response: {},
        tabs: {
            current: '',
            list: {}
        }
    };

    componentWillMount() {
        this.state.tabs.current = 'pending';
        this.state.tabs.list = {
            pending: {
                label: window.Translation(msg`Tutte`),
                description: window.Translation(msg`Tutte le scommesse disponibili per il cashout`)
            },
            livebet: {
                label: window.Translation(msg`Live`),
                description: window.Translation(msg`Scommesse live disponibili al cashout`)
            }
        };

        // CashoutService.loadConfig();

        // Scarica la lista schedine o la paginetta resta vuota
        this.openBetsInterval = setInterval(() => this.fetchOpenBets(), 60e3);
        this.oddsInterval = setInterval(() => this.fetchOdds(), 1.7e3);
        this.performFullUpdate();
        Observer.subscribe('ticket-cashout-done', this.performFullUpdate);
        Observer.subscribe('ticket-auto-cashout-save', this.performFullUpdate);

        LFeed.onUpdate(this.rerender = () => this.setState({}));
    }

    componentWillUnmount() {
        clearInterval(this.oddsInterval);
        clearInterval(this.openBetsInterval);
        Observer.unsubscribe('ticket-cashout-done', this.performFullUpdate);
        Observer.unsubscribe('ticket-auto-cashout-save', this.performFullUpdate);

        LFeed.stopUpdate(this.rerender);
    }

    performFullUpdate = () => {
        this.fetchOpenBets().then(() => this.fetchOdds());
    }

    fetchOpenBets() {
        return CashoutService.fetchOpenBets().then(betsList => {
            const bets = betsList.filter(ticket => User.data && ticket.player == User.data.id)
                .filter(ticket => this.state.tabs.current === 'pending' || !!ticket.live);
            this.setState({
                response: {
                    totalpages: 1,
                    totalrecords: bets.length,
                    recordperpage: bets.length,
                    page: 1,
                    lowlimit: 0,
                    data: bets
                }
            });
        })
    }

    fetchOdds() {
        const prematchTicketsList = this.state.response.data.filter(t => !t.live);
        const liveTicketsList = this.state.response.data.filter(t => !!t.live);

        if (this.state.tabs.current === 'pending' && !!prematchTicketsList.length) {
            CashoutService
                .fetchCurrentOddsForPrematchTickets(prematchTicketsList)
                .then(() => this.setState({}));
        }

        if (!!liveTicketsList.length) {
            CashoutService
                .fetchCurrentOddsForLiveTickets(liveTicketsList)
                .then(() => this.setState({}));
        }
    }

    switchTabs(newtab) {
        this.state.tabs.current = newtab;
        this.performFullUpdate();
    }

    render() {
        const tabs = this.state.tabs.list;
        const onSwitchTab = tabKey => this.switchTabs(tabKey);
        const currentTabKey = this.state.tabs.current;

        return <div>
            <C.CashoutTabsContainer>
                {Object.entries(tabs).map(([tabId, item]) => (
                    <C.CashoutTab selected={tabId === currentTabKey} onSwitchTab={() => onSwitchTab(tabId)} name={item.label} />
                ))}
            </C.CashoutTabsContainer>
            <CashoutBetsTable
                {...this.state.response}
                onIdClick={ticket => TicketLogic.printTicket(ticket)}
                onAutoCashout={this.performFullUpdate}
                onPartialCashout={this.performFullUpdate} />
        </div>;
    }
}

export class CashoutBetsTable extends Component {
    state = {
        totalpages: 0,
        totalrecords: 0,
        recordperpage: 0,
        page: 0,
        lowlimit: 0,
        data: [],
        onNavigation: false
    };

    componentWillMount() {
        this.updateLocalState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.updateLocalState(nextProps);
    }

    updateLocalState(props) {
        this.state = props;

        if (!!this.state.onNavigation) {
            this.state.totalpages = 0;

            if (!!this.state.totalrecords && !!this.state.recordperpage) {
                this.state.totalpages = Math.ceil(this.state.totalrecords / this.state.recordperpage);
            }
        }

        this.setState(this.state);
    }

    render({ data, onIdClick = null, onAutoCashout, onPartialCashout }) {
        return <div>
            <div>
                {!this.state.data.length ?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        <C.BetsTable>
                            <C.BetsTableHeader>
                                <tr>
                                    <C.BetsHeadCell><Trans>ID</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Tipo Scommessa</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Cashout</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Puntata</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>N. Eventi</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Quota Totale</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Vincita Potenziale</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell />
                                </tr>
                            </C.BetsTableHeader>
                            {this.state.data.map(bet => <CashoutBetsTableRow row={bet} onIdClick={onIdClick} onAutoCashout={onAutoCashout} onPartialCashout={onPartialCashout} />)}
                        </C.BetsTable>
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => { this.state.onNavigation(page, page * this.state.recordperpage - this.state.recordperpage) }}
                            isLastPage={this.state.totalpages === this.state.page}
                        />}
                    </Fragment>}
            </div>
        </div>;
    }
}

export class CashoutBetsTableRow extends Component {
    state = {
        showdetails: true,
        cashoutvalue: null,
        cashouterrors: {
            'cannot-cashout-max-odds-exceeded': window.Translation(msg`Una o più quote superano il valore massimo consentito per poter effettuare il cashout`),
            'bet-not-found': window.Translation(msg`Scommessa non identificata. Impossibile procedere con il cashout`),
            'login': window.Translation(msg`Devi essere collegato al sito per poter usufruire del cashout`),
            'disabled': window.Translation(msg`Siamo spiacenti ma questa funzionalità non è abilitata`),
            'cannot-cashout': window.Translation(msg`La scommessa non rispetta i parametri per il cashout`),
            'outdated-events': window.Translation(msg`La scommessa non rispetta le legature o un evento al suo interno sta per iniziare`),
            'cannot-cashout:not-your-ticket': window.Translation(msg`Questa scommessa non appartiene al tuo account`)
        }
    };

    confirmCashoutInfo(ticket) {
        if (!window.confirm("Do you want to cashout the ticket?"))
            return;

        if (!CashoutService.calculateCashoutWin(ticket)) {
            this.setState({ cashoutvalue: false });
            return;
        }

        CashoutService.doCashout(ticket, this.state.cashoutvalue)
            .catch(error => {
                alert(!!this.state.cashouterrors[error] ? this.state.cashouterrors[error] : error);
            })
            .then(() => {
                this.setState({ cashoutvalue: false });
                Observer.notify('ticket-cashout-done', ticket);
                alert("Cashout succesful")
            });
    }

    static printDateFormat(datestring) {
        const d = new Date(datestring);
        return <span>
            {d.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
            &nbsp;
            {d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
        </span>;
    }

    static outcomeStatusDescription(status) {
        return OUTCOMES_STATUS(status);
    }

    render({ row, onIdClick = null, onAutoCashout, onPartialCashout }) {
        const eventipresi = row.odds.filter(o => !!o.status && o.status !== 'L' && o.status !== 'P').length;
        const quotatotale = Math.floor(row.odds.reduce((odds, o) => odds * (CashoutService.getUpdatedOdd(o.id) || o.value), 1) * 100) / 100;

        const ticket = row;
        const cashoutAmountPreview = CashoutService.calculateCashoutWin(ticket);
        const isCashoutAllowed = !!cashoutAmountPreview;

        const isTicketOpen = this.state.showdetails;

        const onCashoutRequest = () => this.confirmCashoutInfo(ticket)
        const onToggleTicketBody = () => this.setState({ showdetails: !isTicketOpen })

        return <C.TicketSummary
            row={row}
            ticket={ticket}
            onIdClick={onIdClick}
            onCashoutRequest={onCashoutRequest}
            isCashoutAllowed={isCashoutAllowed}
            cashoutAmountPreview={cashoutAmountPreview}
            eventipresi={eventipresi}
            quotatotale={quotatotale}
            isTicketOpen={isTicketOpen}
            onToggleTicketBody={onToggleTicketBody}
            onAutoCashout={onAutoCashout}
            onPartialCashout={onPartialCashout}
        >
            <C.TicketTable>
                {isTicketOpen && ticket.odds.map(outcome => {
                    const item = outcome;

                    const dateFormat = CashoutBetsTableRow.printDateFormat(item.date);
                    const statusDescription = CashoutBetsTableRow.outcomeStatusDescription(item.status);

                    const currentOdds = CashoutService.getUpdatedOdd(item.id);
                    const showLiveOdds = item.date <= Date.now();
                    const liveEvent = LFeed.getEvent('/event/' + item.id.split('-').slice(-3)[0]);

                    return <C.TicketSelectionTemplate
                        item={outcome}
                        dateFormat={dateFormat}
                        statusDescription={statusDescription}
                        currentOdds={currentOdds}
                        showLiveOdds={showLiveOdds}
                        liveEvent={liveEvent} />;
                })}
            </C.TicketTable>
        </C.TicketSummary>
    }
}